import { useSyncExternalStore } from "react";
import { useEngineContext } from "../app/EngineProvider";
import type { ControlValue } from "../state/controlStore";
import type { ParameterPath } from "../state/parameterRoutes";
import type { UserControls } from "../state/types";

/**
 * Reads user controls from the ControlStore.
 *
 * The store is the single holder; React subscribes to it rather than owning the
 * values, so the audio side never depends on a React render to see a change.
 */
export function useControls(): {
  controls: UserControls;
  set: (path: ParameterPath, value: ControlValue) => void;
} {
  const { store } = useEngineContext();
  const controls = useSyncExternalStore(store.subscribe, store.getSnapshot);
  return {
    controls,
    set: (path, value) => {
      store.set(path, value);
    },
  };
}
